import React, { ReactNode, useEffect } from 'react';
import { usePageTitle } from '@contexts/PageTitleContext';

type CustomPageTitleProps = {
    children: ReactNode;
};

export const CustomPageTitle: React.FC<CustomPageTitleProps> = ({ children }) => {
    const { setCustomPageTitle } = usePageTitle();

    useEffect(() => {
        setCustomPageTitle(children);
        return () => {
            setCustomPageTitle(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
